import React from 'react';
import {
  Row, Col, Card, Form, Input, Button, message,
  Typography, Divider, Avatar, Breadcrumb, Spin, Upload,
} from 'antd';
import {
  UserOutlined, LockOutlined, PhoneOutlined,
  IdcardOutlined, SaveOutlined, HomeOutlined, SettingOutlined,
  CameraOutlined, LoadingOutlined, TeamOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import { initHandler, ajaxViewHandler, ajaxHandler, setConfig, extractResult } from '../../store/actions';
import { apiClient } from '../../store/store';
import { Helmet } from 'react-helmet';
import Cookies from 'js-cookie';
import Config from '../../Config';

const buildFotoUrl = (path) => {
  if (!path) return null;
  if (path.startsWith('http')) return path;
  const base = (apiClient.defaults.baseURL || '').replace(/\/$/, '');
  return base ? base + path : path;
};

const { Text } = Typography;
const config = new Config();

const API_URL   = 'auth/api/profil/';
const FOTO_URL  = 'auth/api/profil/foto/';

class FormProfil extends React.Component {
  formInfoRef   = React.createRef();
  formPassRef   = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      loading:       false,
      savingInfo:    false,
      savingPass:    false,
      savingFoto:    false,
      profil: { nama: '', nip: '', no_hp: '', username: '', foto: null, jabatan_nama: '' },
      fotoPreview:   null,   // URL object preview sebelum upload
      fotoFile:      null,   // File object yang dipilih
    };
  }

  UNSAFE_componentWillMount() { this.props.initHandler(); }

  componentDidMount() { this.loadProfil(); }

  componentWillUnmount() {
    if (this.state.fotoPreview) URL.revokeObjectURL(this.state.fotoPreview);
  }

  async loadProfil() {
    this.setState({ loading: true });
    const action = await this.props.ajaxViewHandler('get', API_URL);
    const { isSuccess, responseMsg: data } = extractResult(action);
    if (isSuccess) {
      const fotoDisplay = buildFotoUrl(data.foto);
      this.setState({ profil: { ...data, foto: fotoDisplay } });
      this.formInfoRef.current && this.formInfoRef.current.setFieldsValue({
        nama:  data.nama,
        nip:   data.nip,
        no_hp: data.no_hp,
      });
    }
    this.setState({ loading: false });
  }

  async saveInfo(values) {
    this.setState({ savingInfo: true });
    const action = await this.props.ajaxViewHandler('patch', API_URL, {
      nama:  values.nama,
      nip:   values.nip   || '',
      no_hp: values.no_hp || '',
    });
    const { isSuccess, responseMsg: err } = extractResult(action);
    if (isSuccess) {
      message.success({ content: 'Informasi profil berhasil disimpan.', duration: 2, key: 'toast' });
      this.setState({ profil: { ...this.state.profil, ...values } });
      this.props.setConfig({ nama: values.nama });
    } else {
      message.error({ content: typeof err === 'string' ? err : (err && err.detail) || 'Gagal menyimpan.', duration: 2, key: 'toast' });
    }
    this.setState({ savingInfo: false });
  }

  async savePassword(values) {
    this.setState({ savingPass: true });
    const action = await this.props.ajaxViewHandler('patch', API_URL, {
      password_lama: values.password_lama,
      password:      values.password,
    });
    const { isSuccess, responseMsg: err } = extractResult(action);
    if (isSuccess) {
      message.success({ content: 'Password berhasil diubah. Anda akan logout dalam 2 detik...', duration: 2, key: 'toast' });
      setTimeout(() => {
        const cookieName = config.get_cookie_name();
        Cookies.remove(cookieName);
        Cookies.remove(cookieName + '_upt');
        Cookies.remove(cookieName + '_isNotice');
        Cookies.remove(cookieName + '_username');
        Cookies.remove(cookieName + '_expiry');
        Cookies.remove(cookieName + '_refresh');
        this.props.setConfig({ isLogin: false, uptDipilih: '', nama: '', username: '' });
        window.location.reload();
      }, 2000);
    } else {
      message.error({ content: typeof err === 'string' ? err : (err && err.detail) || 'Gagal mengubah password.', duration: 2, key: 'toast' });
    }
    this.setState({ savingPass: false });
  }

  async saveFoto() {
    const { fotoFile } = this.state;
    if (!fotoFile) return;
    this.setState({ savingFoto: true });

    const formData = new FormData();
    formData.append('foto', fotoFile);

    try {
      const token = Cookies.get(config.get_cookie_name());
      const response = await apiClient.patch(FOTO_URL, formData, {
        headers: { Authorization: token || '' },
      });
      const fotoUrl = response.data.foto;
      const fotoDisplay = buildFotoUrl(fotoUrl);
      message.success({ content: 'Foto profil berhasil diperbarui.', duration: 2, key: 'toast' });
      this.setState({
        profil:      { ...this.state.profil, foto: fotoDisplay },
        fotoFile:    null,
        fotoPreview: null,
      });
      this.props.setConfig({ pp: fotoDisplay || process.env.PUBLIC_URL + '/user.png' });
    } catch (err) {
      const detail = err.response && err.response.data && err.response.data.detail;
      message.error({ content: detail || 'Gagal mengunggah foto.', duration: 2, key: 'toast' });
      console.error('Upload foto error:', err.response || err.message);
    }
    this.setState({ savingFoto: false });
  }

  handleFotoPick = (file) => {
    const isImage = file.type.startsWith('image/');
    const isLt5M  = file.size / 1024 / 1024 < 5;
    if (!isImage) { message.error({ content: 'File harus berupa gambar.', duration: 2, key: 'toast' }); return false; }
    if (!isLt5M)  { message.error({ content: 'Ukuran gambar maksimal 5 MB.', duration: 2, key: 'toast' }); return false; }
    if (this.state.fotoPreview) URL.revokeObjectURL(this.state.fotoPreview);
    const preview = URL.createObjectURL(file);
    this.setState({ fotoFile: file, fotoPreview: preview });
    return false; // cegah auto-upload
  };

  _inisial(nama) {
    if (!nama) return '?';
    return nama.split(' ').slice(0, 2).map(w => w[0]).join('').toUpperCase();
  }

  render() {
    const { loading, savingInfo, savingPass, savingFoto, profil, fotoPreview, fotoFile } = this.state;
    const avatarSrc = fotoPreview || profil.foto || null;

    const sectionCard = (title, icon, color, children) => (
      <Card
        style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', overflow: 'hidden', marginBottom: 20 }}
        bodyStyle={{ padding: 0 }}
      >
        <div style={{
          padding: '14px 24px',
          background: `linear-gradient(135deg, ${color}22, ${color}11)`,
          borderBottom: `2px solid ${color}33`,
          display: 'flex', alignItems: 'center', gap: 10,
        }}>
          <span style={{ color, fontSize: 18 }}>{icon}</span>
          <Text strong style={{ fontSize: 15, color: '#222' }}>{title}</Text>
        </div>
        <div style={{ padding: '24px 28px' }}>{children}</div>
      </Card>
    );

    return (
      <div>
        <Helmet>
          <title>Profil Saya | {config.get_site_info().name}</title>
          <style>{`
            .profil-form-wrap input,
            .profil-form-wrap textarea,
            .profil-form-wrap .ant-input {
              text-transform: none !important;
            }
          `}</style>
        </Helmet>


        <Spin spinning={loading}>
          <Row gutter={[20, 20]}>

            {/* ===== Kolom kiri — avatar + foto upload ===== */}
            <Col xs={24} md={7}>
              <Card
                style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', textAlign: 'center', overflow: 'hidden' }}
                bodyStyle={{ padding: 0 }}
              >
                {/* Banner */}
                <div style={{
                  background: 'linear-gradient(135deg, #1890ff, #722ed1)',
                  padding: '36px 20px 20px',
                }}>
                  <div style={{ position: 'relative', display: 'inline-block' }}>
                    <Avatar
                      size={90}
                      src={avatarSrc}
                      style={{
                        background: 'rgba(255,255,255,0.25)',
                        fontSize: 34,
                        fontWeight: 700,
                        color: '#fff',
                        border: '3px solid rgba(255,255,255,0.5)',
                      }}
                    >
                      {!avatarSrc && this._inisial(profil.nama)}
                    </Avatar>

                    {/* Tombol kamera di atas avatar */}
                    <Upload
                      accept="image/*"
                      showUploadList={false}
                      beforeUpload={this.handleFotoPick}
                    >
                      <div style={{
                        position: 'absolute',
                        bottom: 0, right: 0,
                        width: 28, height: 28,
                        borderRadius: '50%',
                        background: '#fff',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        cursor: 'pointer',
                        border: '2px solid #1890ff',
                      }}>
                        <CameraOutlined style={{ color: '#1890ff', fontSize: 13 }} />
                      </div>
                    </Upload>
                  </div>

                  <div style={{ marginTop: 14 }}>
                    <div style={{ color: '#fff', fontWeight: 700, fontSize: 17, lineHeight: 1.3 }}>
                      {profil.nama || '—'}
                    </div>
                    <div style={{ color: 'rgba(255,255,255,0.75)', fontSize: 13, marginTop: 4 }}>
                      @{profil.username}
                    </div>
                  </div>
                </div>

                {/* Info + tombol simpan foto */}
                <div style={{ padding: '20px 24px' }}>
                  {[
                    { label: 'NIP',     value: profil.nip          || '—', icon: <IdcardOutlined /> },
                    { label: 'No. HP',  value: profil.no_hp        || '—', icon: <PhoneOutlined />  },
                    { label: 'Jabatan', value: profil.jabatan_nama || '—', icon: <TeamOutlined />   },
                  ].map(item => (
                    <div key={item.label} style={{
                      display: 'flex', alignItems: 'center', gap: 10,
                      padding: '10px 0',
                      borderBottom: '1px solid #f0f0f0',
                    }}>
                      <span style={{ color: '#1890ff', fontSize: 16, flexShrink: 0 }}>{item.icon}</span>
                      <div>
                        <div style={{ fontSize: 11, color: '#aaa' }}>{item.label}</div>
                        <div style={{ fontSize: 13, fontWeight: 600, color: '#333' }}>{item.value}</div>
                      </div>
                    </div>
                  ))}

                  {/* Tombol simpan foto — muncul hanya jika ada foto baru dipilih */}
                  {fotoFile && (
                    <div style={{ marginTop: 16 }}>
                      <div style={{
                        background: '#e6f7ff',
                        border: '1px solid #91d5ff',
                        borderRadius: 8,
                        padding: '8px 12px',
                        fontSize: 12,
                        color: '#0050b3',
                        marginBottom: 10,
                      }}>
                        Foto baru dipilih. Klik simpan untuk mengunggah.
                      </div>
                      <Button
                        type="primary"
                        icon={savingFoto ? <LoadingOutlined /> : <CameraOutlined />}
                        loading={savingFoto}
                        onClick={() => this.saveFoto()}
                        style={{ borderRadius: 8, width: '100%' }}
                        size="large"
                      >
                        Simpan Foto
                      </Button>
                    </div>
                  )}

                  {!fotoFile && (
                    <div style={{ marginTop: 16, fontSize: 12, color: '#aaa', textAlign: 'center' }}>
                      <CameraOutlined /> Klik ikon kamera pada foto untuk mengubah
                    </div>
                  )}
                </div>
              </Card>
            </Col>

            {/* ===== Kolom kanan — form ===== */}
            <Col xs={24} md={17} className="profil-form-wrap">

              {/* Informasi Pribadi */}
              {sectionCard('Informasi Pribadi', <UserOutlined />, '#1890ff',
                <Form
                  ref={this.formInfoRef}
                  layout="vertical"
                  onFinish={v => this.saveInfo(v)}
                >
                  <Row gutter={16}>
                    <Col xs={24} md={24}>
                      <Form.Item
                        label="Nama Lengkap"
                        name="nama"
                        rules={[{ required: true, message: 'Nama wajib diisi' }]}
                      >
                        <Input
                          prefix={<UserOutlined style={{ color: '#bbb' }} />}
                          placeholder="Masukkan nama lengkap"
                          size="large"
                          style={{ borderRadius: 8, textTransform: 'none' }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Form.Item label="NIP" name="nip">
                        <Input
                          prefix={<IdcardOutlined style={{ color: '#bbb' }} />}
                          placeholder="Nomor Induk Pegawai"
                          size="large"
                          style={{ borderRadius: 8, textTransform: 'none' }}
                          maxLength={20}
                          onKeyPress={(e) => { if (!/\d/.test(e.key)) e.preventDefault(); }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Form.Item label="No. HP / WhatsApp" name="no_hp">
                        <Input
                          prefix={<PhoneOutlined style={{ color: '#bbb' }} />}
                          placeholder="contoh: 08123456789"
                          size="large"
                          style={{ borderRadius: 8, textTransform: 'none' }}
                          maxLength={15}
                          onKeyPress={(e) => { if (!/\d/.test(e.key)) e.preventDefault(); }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Form.Item label="Jabatan">
                        <Input
                          prefix={<TeamOutlined style={{ color: '#bbb' }} />}
                          value={profil.jabatan_nama || '—'}
                          size="large"
                          readOnly
                          style={{
                            borderRadius: 8,
                            background: '#f5f5f5',
                            color: '#666',
                            cursor: 'not-allowed',
                          }}
                          suffix={
                            <span style={{ fontSize: 11, color: '#aaa' }}>tidak dapat diubah</span>
                          }
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                      type="primary"
                      htmlType="submit"
                      icon={<SaveOutlined />}
                      size="large"
                      loading={savingInfo}
                      style={{ borderRadius: 8, paddingLeft: 28, paddingRight: 28 }}
                    >
                      Simpan Informasi
                    </Button>
                  </div>
                </Form>
              )}

              {/* Ubah Password */}
              {sectionCard('Keamanan — Ubah Password', <LockOutlined />, '#722ed1',
                <Form
                  ref={this.formPassRef}
                  layout="vertical"
                  onFinish={v => this.savePassword(v)}
                >
                  <Form.Item
                    label="Password Lama"
                    name="password_lama"
                    rules={[{ required: true, message: 'Password lama wajib diisi' }]}
                  >
                    <Input.Password
                      prefix={<LockOutlined style={{ color: '#bbb' }} />}
                      placeholder="Masukkan password lama"
                      size="large"
                      style={{ borderRadius: 8, textTransform: 'none' }}
                    />
                  </Form.Item>

                  <Divider style={{ margin: '4px 0 16px' }} />

                  <Row gutter={16}>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Password Baru"
                        name="password"
                        rules={[
                          { required: true, message: 'Password baru wajib diisi' },
                          { min: 6, message: 'Minimal 6 karakter' },
                        ]}
                      >
                        <Input.Password
                          prefix={<LockOutlined style={{ color: '#bbb' }} />}
                          placeholder="Minimal 6 karakter"
                          size="large"
                          style={{ borderRadius: 8, textTransform: 'none' }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Konfirmasi Password Baru"
                        name="konfirmasi"
                        dependencies={['password']}
                        rules={[
                          { required: true, message: 'Konfirmasi password wajib diisi' },
                          ({ getFieldValue }) => ({
                            validator(_, val) {
                              if (!val || getFieldValue('password') === val) return Promise.resolve();
                              return Promise.reject('Password tidak cocok!');
                            },
                          }),
                        ]}
                      >
                        <Input.Password
                          prefix={<LockOutlined style={{ color: '#bbb' }} />}
                          placeholder="Ulangi password baru"
                          size="large"
                          style={{ borderRadius: 8, textTransform: 'none' }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <div style={{
                    background: '#fffbe6',
                    border: '1px solid #ffe58f',
                    borderRadius: 8,
                    padding: '10px 14px',
                    marginBottom: 20,
                    fontSize: 12,
                    color: '#856404',
                  }}>
                    <span role="img" aria-label="peringatan">⚠️</span> Setelah mengubah password, Anda akan diminta login ulang.
                  </div>

                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                      type="primary"
                      htmlType="submit"
                      icon={<SaveOutlined />}
                      size="large"
                      loading={savingPass}
                      style={{
                        borderRadius: 8,
                        paddingLeft: 28,
                        paddingRight: 28,
                        background: '#722ed1',
                        borderColor: '#722ed1',
                      }}
                    >
                      Ubah Password
                    </Button>
                  </div>
                </Form>
              )}

            </Col>
          </Row>
        </Spin>
      </div>
    );
  }
}

const mapStateToProps = state => state.configReducers;

export default connect(
  mapStateToProps,
  { initHandler, setConfig, ajaxViewHandler, ajaxHandler }
)(FormProfil);
